import { useCallback, useEffect, useState } from 'react'
import { Card } from '@campgladiator/cgui-core.atoms.card'
import { Icon } from '@campgladiator/cgui-core.atoms.icon'
import { Heading, Paragraph } from '@campgladiator/cgui-core.atoms.typography'
import { Table } from '../../../common/components'
import {
  combineMetricsFromChallenges,
  parseMetricsForHistoryTable,
} from '../../../common/utility'

const config = process.env

const ScrollIndicator = () => (
  <div className="scroll-indicator">
    <Icon.Line
      name="icon-arrow-circle-right"
      className="scroll-indicator__icon"
    />
  </div>
)

const StatsHistory = ({ challenges }) => {
  const [statsData, setStatsData] = useState([])

  const formatUserStats = useCallback(() => {
    if (challenges?.length) {
      const metrics = combineMetricsFromChallenges(challenges)
      const parsedMetrics = parseMetricsForHistoryTable(metrics)
      setStatsData(parsedMetrics)
    }
  }, [challenges])

  useEffect(() => {
    formatUserStats()
  }, [formatUserStats])

  return (
    <Card raised>
      <div className="stats-history">
        <div className="stats-history__header">
          <img
            className="stats-history__header-img"
            src={`${config.REACT_APP_CDN_URL}folder-heart.svg`}
            alt=""
          />
          <div className="stats-history__header-content">
            <Heading type="h4">History</Heading>
            <Paragraph size="default">Track your progress over time.</Paragraph>
          </div>
        </div>
        <div className="stats-history__content">
          {statsData?.length ? (
            <>
              <Table data={statsData} />
              <ScrollIndicator />
            </>
          ) : (
            <Paragraph size="small" className="stats-history__content-alt-text">
              Your stats will appear here
            </Paragraph>
          )}
        </div>
      </div>
    </Card>
  )
}

export default StatsHistory
